import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import { Link } from '../../../_snowpack/pkg/react-router-dom.js';
import ImgPurpleSky from '../../images/illustrations/purple-sky-with-stars.svg';
import Arrow from '../../icons/arrow.js';
export function ActivateAccount(props) {
  const {
    tenant
  } = props;
  return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(Info, null, /*#__PURE__*/React.createElement(Heading, null, "Activate account"), /*#__PURE__*/React.createElement(SubHeading, null, "Activate your account now. Still developing?", ' ', /*#__PURE__*/React.createElement(Link, {
    to: `/settings/tenants/${tenant.identifier}`
  }, "Check your current usage."))), /*#__PURE__*/React.createElement(ActivateLink, {
    to: `/settings/tenants/${tenant.identifier}/plans`
  }, "Activate now ", /*#__PURE__*/React.createElement(Arrow, {
    direction: "right",
    size: 15
  })));
}
const Outer = styled.div.withConfig({
  displayName: "activate-account__Outer",
  componentId: "sc-1eyxgrn-0"
})(["margin-block-end:25px;background-image:url('", "');background-repeat:no-repeat;background-size:cover;border-radius:8px;color:#fff;padding:50px 90px;display:flex;justify-content:space-between;align-items:center;"], ImgPurpleSky);
const Info = styled.div.withConfig({
  displayName: "activate-account__Info",
  componentId: "sc-1eyxgrn-1"
})([""]);
const Heading = styled.h3.withConfig({
  displayName: "activate-account__Heading",
  componentId: "sc-1eyxgrn-2"
})(["font-size:41px;line-height:1;margin:0 0 15px;"]);
const SubHeading = styled.div.withConfig({
  displayName: "activate-account__SubHeading",
  componentId: "sc-1eyxgrn-3"
})(["a{text-decoration:underline !important;&:hover{text-decoration:none !important;}}"]);
const ActivateLink = styled(Link).withConfig({
  displayName: "activate-account__ActivateLink",
  componentId: "sc-1eyxgrn-4"
})(["background:#a7faa0;display:block;text-decoration:none;padding:17px 22px;color:#4d525b !important;font-weight:600;border-radius:4px;&:hover{background:#a7faa0ee;}&:active{transform:scale(0.95);}> svg{display:inline-block;margin-inline-start:25px;}"]);